export default __webpack_public_path__ + "static/media/home.3f7b2fee.png";